import React from 'react'
import Header from '../../../../../component/layout/LandingHeader'
import Footer from '../../../../../component/layout/Footer'


export default function Terms() {
    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">

                <div className="content-section section-padding">
                    <div className="container">
                        {/*Page Can be used in admin Dashboard, Copy From here*/}
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="text-wrap content-page-wrapper">
                                    <h2 className='heading fs-38 fw-700'>Terms of Use for ClearView</h2>
                                    <div className="text-part">
                                        <p>Welcome to ClearView by Digital Apple. These Terms of Use govern your access to and use of ClearView, including any content, functionality, and services offered on or through ClearView.</p>

                                        <h3>Acceptance of the Terms of Use</h3>
                                        <p>By using ClearView, you accept and agree to be bound by these Terms of Use and our Privacy Policy, incorporated herein by reference.</p>
                                        <h3>Access and Account Security</h3>
                                        <p>We reserve the right to withdraw or amend ClearView, and any service or material we provide on ClearView, in our sole discretion without notice. We will not be liable if, for any reason, all or any part of ClearView is unavailable at any time or for any period.</p>

                                        <h3>Intellectual Property Rights</h3>
                                        <p>The content, features, functionality, and design elements of ClearView are owned by Digital Apple, its licensors, or other providers of such material and are protected by copyright, trademark, patent, and other intellectual property or proprietary rights laws.</p>
                                        <h3>Prohibited Uses</h3>
                                        <p>You may use ClearView only for lawful purposes and by these Terms of Use. You agree not to use ClearView in any way that violates any applicable federal, state, local, or international law or regulation.</p>
                                        <h3>Changes to the Terms of Use</h3>
                                        <p>We may revise and update these Terms of Use from time to time in our sole discretion. All changes are effective immediately when we post them.</p>

                                        <h3>Governing Law</h3>
                                        <p>These Terms of Use shall be governed by and construed by the laws of the United Kingdom without giving effect to any choice or conflict of law provision or rule.</p>

                                        <h3>Contact Information</h3>
                                        <p>To ask questions or comment about these Terms of Use, contact us at <a href="mailto:support@clearview360.ai">support@clearview360.ai</a>.</p>


                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}
